import React, { useState } from "react";
import CSFAnswerModule from "./CSFAnswerModule";
import "./CSFSurveyStyles.scss";
import LastActivity from "../../../Last_Activity/LastActivity";
import { Tooltip } from "antd";
import { InfoCircleFilled, ProfileOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { fetchAuditTrail } from "../../../../../slices/Admin/survey-CSF.slice";
import AuditTrail from "../../../../../pages/Survey/AuditTrail";
import { DrawerComponent } from "../../../Drawer/DrawerComponent";
import QuestionInfo from "../../QuestionInfo";

const CSFQuestionModule = ({
  questions = [],
  isOptionalQn: parentOptionalQn,
  submissionStatus,
  surveyId,
  ...rest
}) => {
  const { auditData, selectedCategory, auditLoading } = useSelector(
    (state) => state.CSFSurvey
  );
  const [visibleQnIds, setVisibleQnIds] = useState({});
  const dispatch = useDispatch();
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [drawerType, setDrawerType] = useState(null);
  const [drawerContentData, setDrawerContentData] = useState({});

  const openAuditTrail = (value) => {
    setDrawerType("audit");
    setDrawerVisible(true);
  };

  const handleFetchAuditLog = (qnId) => {
    dispatch(fetchAuditTrail({ preSubId: surveyId, qnId: qnId }));
  };

  const getReferenceTooltip = (qn) => {
    return qn?.reference?.map((ref) => (
      <div className="info-toolTip-wrapper">
        <span>
          <b>{ref?.type}</b>: {ref?.name}
        </span>
      </div>
    ));
  };

  const handleInfoClick = (qn, qnNumber) => {
    const refDescription =
      qn?.reference?.find((ref) => ref.type === "NIST CSF 2.0 Reference")
        ?.description || "";

    setDrawerType("reference");
    setDrawerContentData({
      qnInfo: refDescription,
      qn: qn?.question,
      qnNumber,
    });
    setDrawerVisible(true);
  };

  const topLevelQuestions = questions.filter((qn) => !qn.dependant_question_id);
  const optionalQuestions = questions.filter(
    (qn) => !!qn.dependant_question_id
  );

  const renderQuestionHeader = (qn, index, isOpt = false) => {
    const qnNumber =
      index !== undefined ? `${index < 9 ? "0" : ""}${index + 1}` : "";
    const referenceTooltip = getReferenceTooltip(qn);
    return (
      <div className="question-header">
        <div className="question-wrapper">
          <span className="question">
            {qnNumber && !isOpt && `${qnNumber}.`} {qn.question}
            <InfoCircleFilled
              className="info-icon"
              onClick={() => handleInfoClick(qn, qnNumber)}
            />
          </span>

          <div className="flex">
            {qn?.answer?.last_updated_at && (
              <LastActivity
                updatedAt={qn.answer.last_updated_at}
                qnId={qn.id}
                openAuditTrail={openAuditTrail}
                updateAuditData={handleFetchAuditLog}
              />
            )}
            <Tooltip
              placement="bottomRight"
              overlayClassName="ref-desctiption-tooltip"
              title={referenceTooltip}
            >
              <ProfileOutlined className="ref-icon" />
            </Tooltip>
          </div>
        </div>
      </div>
    );
  };

  const renderOptionalQuestions = (parentId, index) =>
    optionalQuestions
      .filter(
        (optQn) =>
          optQn.dependant_question_id === parentId &&
          visibleQnIds[parentId] === optQn.dependant_option_id
      )
      .map((optQn) => (
        <div className="optional-qns" key={optQn.id}>
          {renderQuestionHeader(optQn, index, true)}
          <CSFAnswerModule
            questionData={optQn}
            setVisibleQnIds={setVisibleQnIds}
            {...rest}
          />
        </div>
      ));

  return (
    <>
      {topLevelQuestions.map((qn, index) => (
        <div className="question-module-wrapper" id={qn.id} key={qn.id}>
          {renderQuestionHeader(qn, index)}
          <div className="question-module-body">
            <CSFAnswerModule
              questionData={qn}
              setVisibleQnIds={setVisibleQnIds}
              {...rest}
            />
            {renderOptionalQuestions(qn.id, index)}
          </div>
        </div>
      ))}
      <DrawerComponent
        content={
          drawerType === "audit" ? (
            <AuditTrail auditData={auditData} loading={auditLoading} />
          ) : drawerType === "reference" ? (
            <QuestionInfo
              infoData={drawerContentData?.qnInfo}
              question={drawerContentData?.qn}
              questionNo={drawerContentData?.qnNumber}
              domain={selectedCategory?.name}
            />
          ) : null
        }
        drawerVisible={drawerVisible}
        onClose={() => setDrawerVisible(false)}
      />
    </>
  );
};

export default CSFQuestionModule;
